<script setup lang="ts">
import { useDist } from "@/api/distributor-query";
import Scope from "./Scope.vue";

const props = defineProps({
	id: { type: String, required: true },
});

const { distributor } = useDist(computed(() => props.id || ""));
</script>

<template>
	<Scope :name="distributor?.name" :image="distributor?.imageUrl" />
</template>
